module.exports = __webpack_public_path__ + "img/crop-01.976c6848.svg";